module.exports = __webpack_public_path__ + "static/media/python-beginner.1c992568.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/python-beginner.png
// module id = 1470
// module chunks = 147